import React, { useMemo } from 'react';
import classNames from 'classnames';
import { Field, Form as FinalForm, FormSpy } from 'react-final-form';
import { FieldArray } from 'react-final-form-arrays';
import { FormattedMessage, useIntl } from '../../../../util/reactIntl';
// Import shared components
import { IconAdd, IconClose, FieldTextInput } from '../../../../components';
import { required } from '../../../../util/validators';

import css from './EditListingDetailsForm.module.css';


const ProgramDaysFieldArray = props => {

  const intl = useIntl();

  const emptySchedule = () => ({
    id: Date.now(),
    startTime: '',
    endTime: '',
    description: ''
  });

  const emptyDay = () => ({
    id: Date.now(),
    schedules: [],
  });

  return (
    <FieldArray name="programDay">
      {({ fields: dayFields }) => (
        <>
          {dayFields.map((dayName, dayIndex) => (
            <div key={dayName} className={css.programDay}>
              <div className={css.programDayTitleHolder}>

                <h3 className={css.programDayTitle}>
                  <FormattedMessage id="EditListingDetailsForm.programDay" values={{ index: dayIndex + 1 }} />
                </h3>
                <button
                  type="button"
                  onClick={() => dayFields.remove(dayIndex)}
                  className={css.programDayRemoveBtn}
                >
                  <IconClose />
                </button>
              </div>

              <FieldArray
                name={`${dayName}.schedules`}
              >
                {({ fields: scheduleFields }) => (
                  <>
                    {scheduleFields.map(
                      (scheduleName, scheduleIndex) => (
                        <div
                          key={scheduleName}
                          className={css.timeAndDescription}
                        >
                          <div className={css.time}>
                            <div className={css.timeHolder}>
                              <FieldTextInput
                                id={`${scheduleName}.startTime`}
                                name={`${scheduleName}.startTime`}
                                type="text"
                                placeholder={intl.formatMessage({
                                  id: 'EditListingDetailsForm.startTime',
                                })}
                                // validate={required(intl.formatMessage({
                                //   id: 'EditListingDetailsForm.defaultRequiredMessage',
                                // }))}
                              />
                              <span className={css.timeLineSeparator} />
                              <FieldTextInput
                                id={`${scheduleName}.endTime`}
                                name={`${scheduleName}.endTime`}
                                type="text"
                                placeholder={intl.formatMessage({
                                  id: 'EditListingDetailsForm.endTime',
                                })}
                                // validate={required(intl.formatMessage({
                                //   id: 'EditListingDetailsForm.defaultRequiredMessage',
                                // }))}
                              />
                            </div>
                            <button
                              type="button"
                              onClick={() => scheduleFields.remove(scheduleIndex)}
                              className={css.programDayRemoveBtn}
                            >
                              <IconClose />
                            </button>
                          </div>

                          <FieldTextInput
                            id={`${scheduleName}.description`}
                            name={`${scheduleName}.description`}
                            className={css.programDayDescription}
                            type="textarea"
                            placeholder={intl.formatMessage({
                              id: 'EditListingDetailsForm.programDayDescriptionPlaceholder',
                            })}
                            validate={required(intl.formatMessage({
                              id: 'EditListingDetailsForm.defaultRequiredMessage',
                            }))}
                          />
                        </div>
                      )
                    )}

                    <button
                      type="button"
                      onClick={() => scheduleFields.push(emptySchedule())}
                      className={css.programDayAddBtn}
                    >
                      <FormattedMessage id="EditListingDetailsForm.programDayAddMoreTimes" />
                    </button>
                  </>
                )}
              </FieldArray>
            </div>
          ))}
          <button
            type="button"
            onClick={() => dayFields.push(emptyDay())}
            className={css.programDayAddBtn}
          >
            <FormattedMessage id="EditListingDetailsForm.programDayAddDay" />
          </button>
        </>
      )}
    </FieldArray>
  );
};

export default ProgramDaysFieldArray;


